import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_REQUEST_ACTIVITY = new HttpContextToken<boolean>(() => false);

export const withSkippedRequestActivity = (): HttpContext =>
  new HttpContext().set(SKIP_REQUEST_ACTIVITY, true);
